// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const withImmutableToJS = require('client-v2/common/components/immutable-to-js')
const withIsVisible = require('client-v2/common/components/is-visible')
// Common container imports
const socialMediums = require('./mediums')
// Sibling imports
const shareModalActions = require('./actions')
const shareModalSelectors = require('./selectors')

function mapStateToProps() {
  return function (state) {
    if (!shareModalSelectors.isVisible(state)) {
      return { isVisible: false }
    }
    return {
      isVisible: true,
      model: shareModalSelectors.model(state),
      socialMediums
    }
  }
}

const mapDispatchToProps = {
  onCopy: shareModalActions.copy,
  onDismiss: shareModalActions.hide,
  onShare: shareModalActions.share
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withIsVisible(
    withImmutableToJS(
      require('./component-dumb')
    )
  )
)
